import styled from 'styled-components'

const ShareStyle = styled.div`
	--shareLinkSizes: var(--sp7x);
	--iconSizes: var(--sp4x);
	--shareLinkMarginRight: var(--sp3x);

	display: flex;

	.share-link {
		width: var(--shareLinkSizes);
		height: var(--shareLinkSizes);
		border: 1px solid var(--primaryColor1);
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: var(--shareLinkMarginRight);
        transition: var(--trTime);

		@media (hover: hover) {
			&:hover {
				background-color: var(--primaryColor1);

				.share-icon {
                    color: var(--primaryColor2);
				}
			}
		}

		&:last-child {
			margin-right: 0;
		}

		.share-icon {
			font-size: var(--iconSizes);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--shareLinkSizes: var(--sp5x);
		--iconSizes: var(--sp3x);
		--shareLinkMarginRight: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--shareLinkSizes: var(--sp5x);
		--iconSizes: var(--sp3x);
		--shareLinkMarginRight: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--shareLinkSizes: var(--sp5x);
		--iconSizes: var(--sp3x);
		--shareLinkMarginRight: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--shareLinkSizes: var(--sp5x);
		--iconSizes: var(--sp3x);
		--shareLinkMarginRight: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--shareLinkSizes: var(--sp4x);
		--iconSizes: var(--sp2-5x);
		--shareLinkMarginRight: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--shareLinkSizes: var(--sp4x);
		--iconSizes: var(--sp2-5x);
		--shareLinkMarginRight: var(--sp2x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--shareLinkSizes: var(--sp4x);
		--iconSizes: var(--sp2-5x);
		--shareLinkMarginRight: var(--sp2x);
	}
`

export default ShareStyle
